import { useEffect, useState } from 'react'
import { isValid, parse } from 'date-fns'

interface IFieldDateBirthValidator {
  isDateBirthValid: boolean
  fieldMessageToDateBirth: string
}

const fieldMessages = {
  required: 'Campo obrigatório',
  invalidDateBirth: 'Data de nascimento inválida'
}

export const useFieldDateBirthValidator = (dateBirth: string): IFieldDateBirthValidator => {
  const [isDateBirthValid, setIsDateBirthValid] = useState(false)
  const [message, setMessage] = useState('')
  
  useEffect(() => {
    if (dateBirth === null) {
      setIsDateBirthValid(false)
      setMessage('')
      return
    }

    const parsedDate = parse(dateBirth, 'dd/MM/yyyy', new Date())
    const isValidDate = isValid(parsedDate)

    if (dateBirth) {
      if (isValidDate) {
        setIsDateBirthValid(true)
        setMessage('')
      } else {
        setIsDateBirthValid(false)
        setMessage(fieldMessages.invalidDateBirth)
      }
     
    } else {
      setIsDateBirthValid(false)
      setMessage(fieldMessages.required)
    }
  }, [dateBirth])

  return {
    isDateBirthValid,
    fieldMessageToDateBirth: message
  }
}